<template>
    <el-card  v-if="this.$route.params.name">
        <h1>{{this.$route.params.name}}</h1>
        <!-- [id: {{ this.$route.params.id }} - 
        name: {{ this.$route.params.name }}] -->
        <p>{{this.$route.params.com}}</p>
        
        <h5>Job Description</h5>
        <p>{{this.$route.params.jd}}</p>
        
        <div>{{this.$route.params.sal}}</div>
        <br>
        <el-tag type="warning"><div>{{this.$route.params.date}}</div></el-tag>
        <el-tag type="info"><div>{{this.$route.params.addr}}</div></el-tag>
        <el-tag type="info"><div>{{this.$route.params.ind}}</div></el-tag>
        <br>
        <el-tag type="info"><div>經驗{{this.$route.params.exp}}</div></el-tag>
        <el-tag type="info"><div>學歷{{this.$route.params.edu}}</div></el-tag>
        <br>
        <br>
        <el-button type="warning" ><a target="_blank" :href="this.$route.params.joblink">前往{{this.$route.params.src}}應徵</a></el-button>
        <br>
        <div class="divblock"></div>
    </el-card >
    <div v-else>
        <br/>
        <p>Please Choose a Job</p>
    </div>
    
</template>

<script>
export default {
  name: "Joblist-details"
};
</script>

<style scoped>
    
@media only screen and (max-width: 500px) {
    .el-card{
        /* margin:  */
        /* margin-right: -4em; */
        margin-left: -1em;
    }
    .el-card__body{
        
        padding: 0 !important;
    }
    .divblock{
        margin: 0;
        margin-top: 1em;
        padding: 0;
        height: 1em;
        width: auto;
        background-color: rgba(253, 188, 91, 0.884);
    }
    h1{
        background-color: rgba(253, 188, 91, 0.884);
        padding: 0.3em;
    }
    p{
        padding: 0.5em;
    }
    a{
        text-decoration: none;
        color: white;
    }

}
@media only screen and (min-width: 501px) {
    .el-card__body{
        margin: 0 ;
        padding: 0 !important;
    }
    .divblock{
        margin: 0;
        margin-top: 1em;
        padding: 0;
        height: 1em;
        width: auto;
        background-color: rgba(253, 188, 91, 0.884);
    }
    h1{
        background-color: rgba(253, 188, 91, 0.884);
        padding: 0.3em;
    }
    p{
        padding: 0.5em;
    }
    a{
        text-decoration: none;
        color: white;
    }
    
}
</style>